export default __webpack_public_path__ + "static/media/story-empty-background.f91b2aea.png";